// Geolocation helpers. requestLocation() must be invoked inside a user gesture
// (a tap) on iOS Safari, otherwise the permission prompt never appears.
export function requestLocation() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve({ ok: false, code: 0 });
    const ok = (p) => resolve({ ok: true, pos: { lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy } });
    navigator.geolocation.getCurrentPosition(
      ok,
      () => navigator.geolocation.getCurrentPosition(ok, (e2) => resolve({ ok: false, code: e2.code }), { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 }),
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 10000 }
    );
  });
}

export function getPosition() {
  return requestLocation().then((r) => (r.ok ? r.pos : null));
}

// Human-friendly reason for a geolocation error code (iOS-aware)
export function geoErrorMessage(code) {
  if (code === 1) return "Location permission was blocked for this site.";
  if (code === 2) return "Location Services appear to be turned off, or no GPS fix is available.";
  if (code === 3) return "Timed out getting a location fix — try again with a clear view of the sky.";
  return "Location is unavailable on this device.";
}
